// `path` prefixes the issue path: Zod 4 dropped the `path` option of `safeParse`.
export const processSafeParseResponse = (ctx, response, path = []) => {
    if (response.success) {
        return;
    }
    const { error: { issues }, } = response;
    const [firstIssue] = issues;
    if (firstIssue) {
        ctx.addIssue({ ...firstIssue, path: [...path, ...firstIssue.path] });
    }
};
export const stripTags = (htmlString) => {
    const domParser = new DOMParser().parseFromString(htmlString, 'text/html');
    return domParser.body.textContent || '';
};
export const isEmptyHTMLText = (htmlString) => !stripTags(htmlString).trim();
